.uic-progress-bar {
  display: block;

  &.uic-progress-bar--dark {
    --uic-progress-bar-color: var(--uic-color-blue4);
    --uic-progress-bar-background-color: var(--uic-color-blue4a50);
  }

  &.uic-progress-bar--light {
    --uic-progress-bar-color: var(--uic-color-white);
    --uic-progress-bar-background-color: var(--uic-color-grey10);
  }

  progress {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background: var(--uic-progress-bar-background-color);
    border: 0;
    color: var(--uic-progress-bar-color);

    // measurement
    width: 100%;

    @media #{$breakpoint_tablet} {
      background: repeating-linear-gradient(to right,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0) 5px,
      var(--uic-progress-bar-background-color) 5px,
      var(--uic-progress-bar-background-color) 20px);
      height: 12px;
    }

    @media #{$breakpoint_desktop} {
      background: repeating-linear-gradient(to right,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0) 6px,
      var(--uic-progress-bar-background-color) 6px,
      var(--uic-progress-bar-background-color) 24px);
      height: 15px;
    }
  }

  progress::-webkit-progress-bar {
    background-color: transparent;
  }

  progress::-webkit-progress-value {
    background-color: var(--uic-progress-bar-color);
  }

  progress::-moz-progress-bar {
    background-color: var(--uic-progress-bar-color);
  }

  progress::-ms-fill {
    border: 0;
  }
}
